import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyUser } from "@/types";

/**
 * This hook is used to remove a company user in the company users
 * for settings query without refetching the entire query.
 */
export const useSetRemoveCompanyUserInCompanyUsersForSettings = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyUserToRemove }: { companyUserToRemove: CompanyUser }) => {
    queryClient.setQueryData(
      ["settings/company-users", currentCompanyId],
      (cachedData: CompanyUser[]) => {
        return cachedData.filter(
          (companyUser) => companyUser.email !== companyUserToRemove.email,
        );
      },
    );
  };
};
